import { useMediaQuery } from "@mui/material";
import React from "react";
import { ImageGrid } from "@/components/ImageGrid";
import { PageModule } from "@/components/PageModule";
import { theme } from "@/theme";
import { ImageAttributes } from "@/store";

export interface ImageGridSliderProps {
  images: ImageAttributes[];
  startAtIndex?: number;
}
export const ImageGridSlider = ({
  images,
  startAtIndex,
}: ImageGridSliderProps) => {
  return (
    <PageModule className="max-w-full bg-primary-50 px-0 md:bg-transparent">
      <ImageGrid images={images} startAtIndex={startAtIndex} />
    </PageModule>
  );
};
